module.exports = __webpack_public_path__ + "img/智能充电桩.3572bc7a.png";